import { useTranslation } from "react-i18next";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_HR_EMPLOYEES_SUBSCRIPTION,
  MY_HR_MY_HR_GET_EMPLOYEES,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";
import { getFullname } from "oc/utils";
import getMothersFullname from "oc/utils/get-mothers-fullname";

type UseMyHrEmployeesParams = {
  page: number;
  pageSize: number;
  searchField: string;
  searchText: string;
  sortDirection: string;
  sortField: string;
};

export const useMyHrEmployees = ({
  page,
  pageSize,
  searchField,
  searchText,
  sortDirection,
  sortField,
}: UseMyHrEmployeesParams) => {
  const { i18n } = useTranslation();

  let innerSearchField =
    searchField && searchText.length > 2 ? searchField : "";
  let innerSearchText = searchText.length > 2 ? searchText : "";

  const { data, loading, error, refetch } = useQuery(
    MY_HR_MY_HR_GET_EMPLOYEES,
    {
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: {
        page,
        pageSize,
        sortField,
        sortDirection,
        searchField: innerSearchField,
        searchText: innerSearchText,
      },
    },
  );

  if (error) {
    console.log({
      component: "useEmployees",
      errorDescription:
        "Error occured when fetch data with MY_HR_MY_HR_GET_EMPLOYEES query",
      error: error,
    });
  }

  if (error) {
    console.log({
      component: "useEmployees",
      errorDescription:
        "Error occured when fetch data with MY_HR_MY_HR_GET_EMPLOYEES query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_HR_EMPLOYEES_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useEmployees",
      errorDescription:
        "Error occured when fetch data with MY_HR_EMPLOYEES_SUBSCRIPTION query",
      error: error,
    });
  }

  let resultData = data?.employees || {
    page: 1,
    pageSize: 25,
    rows: [],
    total: 0,
    totalPages: 1,
  };

  let employees = JSON.parse(JSON.stringify(resultData));

  for (const item of employees.rows as any[]) {
    item.dateOfBirth = new Date(item.dateOfBirth).toLocaleDateString(
      i18n.language,
    );
    item.fullname = getFullname(item) ?? undefined;
    item.mothersfullname = getMothersFullname(item);
  }

  return { data: employees, loading };
};

export default useMyHrEmployees;
